import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "urls-list" }
const _hoisted_2 = { class: "add-block" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_IconButton = _resolveComponent("IconButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (_, idx) => {
      return (_openBlock(), _createBlock(_component_Input, {
        key: idx,
        modelValue: _ctx.value[idx],
        "onUpdate:modelValue": $event => ((_ctx.value[idx]) = $event),
        "vread-from": "valid",
        "onUpdate:valid": $event => (($data.inputs_validity[idx]) = $event),
        class: "input",
        label: _ctx.items_label,
        "right-icon": "trash-04",
        type: "url",
        onRightIcon: () => $options.removeItem(idx),
        onBlur: _cache[0] || (_cache[0] = $event => (_ctx.$emit('blur')))
      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onUpdate:valid", "label", "onRightIcon"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconButton, {
        small: "",
        icon: "plus",
        disabled: !$options.can_add,
        onClick: $options.addItem
      }, null, 8 /* PROPS */, ["disabled", "onClick"]),
      _createElementVNode("span", null, _toDisplayString($props.title), 1 /* TEXT */)
    ])
  ]))
}